import { motion } from "framer-motion";
import { Reveal, SectionLabel } from "./Reveal";

export const Team = ({ section, members = [] }) => {
  if (!section || members.length === 0) return null;

  return (
    <section id="team" data-testid="team-section" className="relative py-24 md:py-32 bg-[#050505] border-t border-white/10">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-16">
          <div>
            <Reveal>
              <SectionLabel index={section.metadata?.section_index || "06"}>{section.eyebrow}</SectionLabel>
            </Reveal>
            <Reveal delay={0.1}>
              <h2 className="font-anton uppercase text-[#FAFAFA] text-5xl md:text-7xl lg:text-8xl leading-[0.9]">
                {section.title} <span className="text-[#E85A24]">{section.title_accent}</span>
              </h2>
            </Reveal>
          </div>
          {section.body && (
            <Reveal delay={0.2}>
              <p className="font-dm text-[#A3A3A3] max-w-sm">{section.body}</p>
            </Reveal>
          )}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-px bg-white/10 border border-white/10">
          {members.map((member, index) => (
            <Reveal key={member.id} delay={index * 0.08}>
              <motion.article
                data-testid={`team-card-${member.id}`}
                className="group relative bg-[#050505] overflow-hidden h-full"
              >
                {member.image && (
                  <div className="relative aspect-[4/5] overflow-hidden">
                    <img
                      src={member.image}
                      alt={member.name}
                      className="w-full h-full object-cover object-top grayscale group-hover:grayscale-0 scale-100 group-hover:scale-105 transition-[transform,filter] duration-700 ease-out"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black via-black/30 to-transparent" />
                  </div>
                )}
                <div className="p-6">
                  <p className="font-oswald uppercase tracking-[0.25em] text-[11px] text-[#E85A24] mb-1">
                    {member.role}
                  </p>
                  <h3 className="font-anton uppercase text-2xl text-[#FAFAFA] leading-none group-hover:text-[#E85A24] transition-colors duration-300">
                    {member.name}
                  </h3>
                  {member.bio && <p className="font-dm text-sm text-[#A3A3A3] leading-relaxed mt-4">{member.bio}</p>}
                  {(member.instagram_url || member.linkedin_url) && (
                    <div className="flex gap-4 mt-5 font-oswald uppercase tracking-[0.15em] text-[10px]">
                      {member.instagram_url && (
                        <a href={member.instagram_url} target="_blank" rel="noopener noreferrer" className="text-[#A3A3A3] hover:text-[#E85A24] transition-colors">
                          Instagram
                        </a>
                      )}
                      {member.linkedin_url && (
                        <a href={member.linkedin_url} target="_blank" rel="noopener noreferrer" className="text-[#A3A3A3] hover:text-[#E85A24] transition-colors">
                          LinkedIn
                        </a>
                      )}
                    </div>
                  )}
                </div>
              </motion.article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
